import { render, staticRenderFns } from "./MultipleChoice.vue?vue&type=template&id=9395792e"
import script from "./MultipleChoice.vue?vue&type=script&lang=ts"
export * from "./MultipleChoice.vue?vue&type=script&lang=ts"
import style0 from "./MultipleChoice.vue?vue&type=style&index=0&id=9395792e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports